const outcomes = [
  {
    icon: "ri-lightbulb-line",
    title: "Improved Financial Knowledge",
    desc: "Graduate with a solid, structured understanding of futures markets, financial instruments, and investment principles that will serve you for life.",
    stat: "Foundation",
    statLabel: "for Life",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "Greater Market Confidence",
    desc: "Move from uncertainty to clarity. Our simulation-based approach builds genuine confidence through practice, not theory alone.",
    stat: "Practice",
    statLabel: "Based Learning",
  },
  {
    icon: "ri-focus-3-line",
    title: "More Disciplined Decision-Making",
    desc: "Develop the mental frameworks and behavioral habits that support consistent, rational financial decision-making over the long term.",
    stat: "Discipline",
    statLabel: "First Approach",
  },
  {
    icon: "ri-plant-line",
    title: "A Stronger Wealth-Building Foundation",
    desc: "Leave the academy with the knowledge, tools, and community to continue building your financial education and long-term wealth strategy.",
    stat: "Long-Term",
    statLabel: "Wealth Focus",
  },
];

export default function Outcomes() {
  return (
    <section className="py-24 px-6 bg-[#2B2D2F] relative overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/site/acad-outcomes-001-1920x800.jpg"
          alt="Nairobi financial education hub"
          className="w-full h-full object-cover object-top opacity-15"
        />
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-4">
            <span className="w-8 h-px bg-[#C9A961]" />
            What You Gain
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white mb-4">
            Outcomes &amp; Benefits
          </h2>
          <p className="text-white/60 text-base max-w-2xl mx-auto font-light leading-relaxed">
            The Harambee Trading Academy is an investment in your financial education. Here is what you can expect to carry forward from your experience with us.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {outcomes.map((item) => (
            <div
              key={item.title}
              className="bg-white/5 border border-white/10 rounded-lg p-8 hover:bg-white/10 hover:border-[#C9A961]/30 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A961]/15 mb-5 group-hover:bg-[#C9A961]/25 transition-colors">
                <i className={`${item.icon} text-[#C9A961] text-xl`} />
              </div>
              <div className="mb-4">
                <div className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#C9A961]">{item.stat}</div>
                <div className="text-white/40 text-[10px] uppercase tracking-widest">{item.statLabel}</div>
              </div>
              <h3 className="font-semibold text-white text-sm mb-3">{item.title}</h3>
              <p className="text-white/50 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="mt-12 text-center">
          <p className="text-white/30 text-xs max-w-2xl mx-auto leading-relaxed italic">
            The Harambee Trading Academy provides financial education only. We do not offer investment advice, manage funds, or guarantee any financial outcomes. All trading involves risk. Our programs are designed to build knowledge and discipline, not to promise returns.
          </p>
        </div>
      </div>
    </section>
  );
}
